import {MutableRefObject, useCallback} from "react";
import {useAppSelector} from "../../../redux/hooks";
import {mySongsPageStore} from "../../../pages/songs-router/modules/my-songs-page-store/mySongsPage.store";
import {useDivRef} from "../../../components/common/hooks/useDivRef";
import {useOnClickOutside} from "../../../components/common/hooks/useOnOutsideClick";
import {MySongsPageMenuType} from "../../../pages/songs-router/modules/my-songs-page-store/mySongsPage.types";
import {useIsDeviceMobile} from "../../../services/device/device-info-hooks";
import {mySongsPageSorters} from "../../../config/my-songs-page-sort";
import {mySongsFiltersStore} from "../../../pages/songs-router/modules/my-songs-filters-store/mySongsFiltersStore";

export interface IFilterSortDropdownMenuLogic {
  label: string;
  onClickMenuToggleHandler: () => void;
  isActive?: boolean;
  isAvailable?: boolean;
  dropdownFilterMenuRef: MutableRefObject<HTMLDivElement>;
}

const menuName: MySongsPageMenuType = `desktop.sort`;

export const useFilterSortDropdownMenuLogic = (): IFilterSortDropdownMenuLogic => {
  const isPhone = useIsDeviceMobile();
  const sortColumn = useAppSelector(mySongsPageStore.getSortColumn);
  const abbreviatedLabel = mySongsPageSorters.getMenuLabel(sortColumn);
  const extendedLabel = `Sort by ${abbreviatedLabel}`;
  const isActive = useAppSelector(() => mySongsPageStore.isMenuActive(menuName));
  const isAvailable = useAppSelector(mySongsFiltersStore.isSorterAvailable);
  const label = isPhone ? abbreviatedLabel : extendedLabel;

  const onClickOutsideMenuCloseHandler = useCallback(() => {
    if (!isActive) {
      // not active, no reason to close
      return;
    }
    mySongsPageStore.removeActiveMenu(menuName);
  }, [isActive]);

  const dropdownFilterMenuRef = useDivRef();
  useOnClickOutside<HTMLDivElement>(dropdownFilterMenuRef, onClickOutsideMenuCloseHandler);

  return {
    isAvailable,
    isActive,
    onClickMenuToggleHandler: () => mySongsPageStore.toggleSingleActiveMenu(menuName),
    label,
    dropdownFilterMenuRef,
  };
}
